module.exports = __webpack_public_path__ + "img/HOME_GIF.a5698595.gif";